import { createFileRoute } from '@tanstack/react-router';

import { ConnectAccountConsentPage } from './ConnectAccountConsentPage';

export const Route = createFileRoute('/_protected/_consumer/connect-account-consent/')({
  component: ConnectAccountConsentPage,
});
